import './_menupage.css';

import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useState, useEffect } from 'react'; // ✅ 有加 useEffect
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { useBrand } from './../brand';

import trashIcon from './../images/Button_iconButton_delete.svg';
import penIcon from './../images/Button_iconButton_edit.svg';

// 同理要有預設值，否則缺 .env 時公司代號是空的，
// 使用者不知道要填什麼，按「開始」還會被後端擋下來。
const DEFAULT_COMPANY_ID = process.env.REACT_APP_COMPANY_ID || "ormaster";


const MainPage = () => {
  const brand = useBrand();
  const cookies = new Cookies();

  const ref = useRef(null);
  const roomName = useRef(null);
  const newName = useRef(null);

  const navigate  = useNavigate();
  let roomList = cookies.get('roomList');  
  if( roomList === undefined){
    roomList = [];
  }

  let [listComponent, setListComponent] = useState(roomList);
  const [open, setOpen] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [listID, setListID] = useState(null);
  const [companyId, setCompanyId] = useState(DEFAULT_COMPANY_ID);
  const [role, setRole] = useState('host');
  const cancelButtonRef = useRef(null);

  // Jitsi 會把房名正規化成小寫，這裡先統一，避免 JWT 的 room claim 與白板網址對不上。
  const enterRoom = (rawRoom) => {
    const room = String(rawRoom || '').trim().toLowerCase();
    navigate(`/${room}?company=${companyId}&role=${role}`);
  };

  const startMeeting = () => {
    const room = String(ref.current.value || '').trim().toLowerCase();

    if (!room) {
      alert('請輸入房間名');
      return;
    }

    // 初始化 roomList
    if (roomList === undefined || roomList === null) {
      roomList = [];
    }

    // 如果房名不在 cookies 中，才新增
    if (!roomList.includes(room)) {
      roomList.push(room);
      cookies.set('roomList', roomList);
    }

    enterRoom(room);
  };

  // Join Meeting
  const joinMeeting = (index) => {
    enterRoom(listComponent[index]);
  };

  // Add Room
  const addRoom = () => {
    const newList = [...listComponent];
    if(newName.current.value !== '') {
      newList.push(newName.current.value);
      setListComponent(newList);
      cookies.set('roomList', newList);
      setOpenNew(false);
    } else {
      alert('Please fill up the room name.')
    }
  };

  // Delete Meeting 
  const deleteMeeting = (index) => {
    const newList = [...listComponent];
    newList.splice(index, 1);
    setListComponent(newList);
    cookies.set('roomList', newList);
  };

  // Edit Room Name
  const editRoomName = () => {
    if(roomName.current.value !== '') {
    listComponent[listID] = roomName.current.value;
      setListComponent(listComponent);
      cookies.set('roomList', listComponent);
      setOpen(false);
    } else {
      alert('Please fill up the room name.')
    }
  };

  // Toggle Modal
  const openModal = (index) => {
    setListID(index);
    setOpen(true);
  }
  const closeModal = () => {
    setOpen(false);
  }
  const openModalNew = () => {
    setOpenNew(true);
  }
  const closeModalNew = () => {
    setOpenNew(false);
  }

  return (
    <div className="menuPage">
      <header>
        {brand.logo ? (
          <img src={brand.logo} alt={brand.appName} />
        ) : (
          <p style={{ color: "white", fontSize: "36px" }}>{brand.appName}</p>
        )}
      </header>
      <div className="main-container">
      <div className="main-box">
  <div className="input-group">
    <input
      type="text"
      id="companyId"
      placeholder="輸入公司代號"
      value={companyId}
      onChange={(e) => setCompanyId(e.target.value)}
    />
  </div>

  <div className="input-group">
    <input
      type="text"
      id="roomName"
      placeholder="輸入房間名稱"
      ref={ref}
      defaultValue=""
    />
  </div>

  <div className="input-group">
    <select
      id="role"
      value={role}
      onChange={(e) => setRole(e.target.value)}
    >
      <option value="host">主持人（醫師端）</option>
      <option value="guest">參與者（觀看端）</option>
    </select>
  </div>

  <div className="start-btn-wrapper">
    <button className="start-btn" onClick={startMeeting}>開始</button>
  </div>
</div>
      </div>
      <div className="menu-container">
        <div className="menu-box">
          { 
            listComponent.map((list, index) => (
            <div key={index} className="room-list-box">
              <div className="list-box " onClick={() => joinMeeting(index)}>{list}</div>
                <div className="icon-box">
                  <button onClick={() => deleteMeeting(index)}>
                    <img src={trashIcon} alt={'delete'}></img>
                  </button>
                  <button onClick={() => openModal(index)}>
                    <img src={penIcon} alt={'edit'}></img>
                  </button>
                </div>
            </div>
          ))}
        </div>
      </div>
      <button className="add-room collapse" onClick={() => openModalNew()}>ADD</button>

      <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 custom-bg bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 custom-width">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-6 sm:w-full sm:max-w-lg custom-bg-color">
                <div className="custom-bg-color px-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="custom-marg">
                    <div className="mt-3 text-center sm:mt-0">
                      <div className="custom-box">
                        <input 
                          type="text" 
                          placeholder="房间名"
                          ref={roomName}
                          id="roomName"
                          name="roomName"
                          defaultValue=""
                        />
                      </div>
                      <div className="custom-dialog-button">
                        <button onClick={() => closeModal()}>Cancel</button>
                        <button onClick={() => editRoomName()}>Edit Room</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
      </Transition.Root>
      {/*  */}
      <Transition.Root show={openNew} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpenNew}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 custom-bg bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 custom-width">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-6 sm:w-full sm:max-w-lg custom-bg-color">
                <div className="custom-bg-color px-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="custom-marg">
                    <div className="mt-3 text-center sm:mt-0">
                      <div className="custom-box">
                        <input 
                          type="text" 
                          placeholder="房间名"
                          ref={newName}
                          id="newName"
                          name="newName"
                          defaultValue=""
                        />
                      </div>
                      <div className="custom-dialog-button">
                        <button onClick={() => closeModalNew()}>Cancel</button>
                        <button onClick={() => addRoom()}>Add Room</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
      </Transition.Root>
    </div>
  );

}

export default MainPage;


